module.exports = __webpack_public_path__ + "img/step2.d3213c20.png";